import '@tencent/exeditor3-ui-kit/dist/color-palette.js';
import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { parseStyle, stringifyStyles } from './utils.js';
// NOTE: Firefox 会优先使用 border，不用兼容 Firefox 的 color
const defaultPresetStyles = [
    '',
    'border-width: 2px 0 0 0; border-style: dashed; border-color: var(--exeditor-hr-color)',
    'border-width: 2px 0 0 0; border-style: dotted; border-color: var(--exeditor-hr-color)',
    'border-width: 6px 0 0 0; border-style: double; border-color: var(--exeditor-hr-color)',
];
const styles = `
.exeditor-hr-wrapper {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  padding-top: 1em;
  padding-bottom: 1em;
}
.exeditor-hr-wrapper hr {
  margin: 0;
}
`;
export class HrPlugin {
    constructor(opt = {}) {
        this.name = 'hr';
        this.spec = {
            type: 'node',
            matchSelector: 'hr',
            attrs: {
                style: {
                    parse: (node) => node.getAttribute('style'),
                    toDOMAttribute: (style) => (style ? { style } : null),
                },
            },
            toDOM: 'hr',
        };
        this.insert = (attr = {}) => {
            this.editor.focus().selection().gapIfANode().replaceWithNode(this, attr);
        };
        this.set = (attr = {}) => this.editor.focus().selection().replaceWithNode(this, attr);
        this.opt = {
            presetStyles: defaultPresetStyles,
            ...opt,
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    editView(node) {
        // 为了增加点击面积，易于选中和拖拽
        const eltWrapper = document.createElement('div');
        eltWrapper.className = 'exeditor-hr-wrapper';
        const hr = document.createElement('hr');
        if (node.attrs.style) {
            hr.setAttribute('style', node.attrs.style);
        }
        eltWrapper.appendChild(hr);
        return eltWrapper;
    }
    capabilities() {
        return {
            commands: {
                set: this.set,
                insert: this.insert,
            },
            shortcuts: {
                'Mod-_': () => this.insert(),
            },
            styles,
        };
    }
    /** 更新 style 或者以 style 插入一个 */
    updateOrInsert({ attr, mode, } = {}) {
        const selection = this.editor.focus().selection();
        const isSelected = selection.isNode((node) => node.isLeaf && node.type.name === this.name);
        if (isSelected && mode === 'merge') {
            const oldStyle = selection.getNodeAttr(this.name, 'style');
            const oldStyles = parseStyle(oldStyle);
            const newStyles = parseStyle(attr === null || attr === void 0 ? void 0 : attr.style);
            const newStyle = stringifyStyles({ ...oldStyles, ...newStyles });
            selection.updateNodeAttr(this.name, 'style', newStyle);
        }
        else if (isSelected) {
            selection.updateNodeAttr(this.name, 'style', attr === null || attr === void 0 ? void 0 : attr.style);
        }
        else {
            selection.gapIfANode().replaceWithNode(this.name, attr);
        }
    }
    renderColorPicker() {
        const colorButton = document.createElement('exeditor-toolbar-button');
        colorButton.slot = 'option';
        colorButton.in = 'dropdown';
        colorButton.appendChild(new Text(`${this.editor.t('分隔线颜色')}`));
        colorButton.separateDropdown = true;
        const palette = document.createElement('exeditor-color-palette');
        palette.t = this.editor.t.bind(this.editor);
        palette.editor = this.editor;
        palette.slot = 'pop-content';
        palette.key = 'EXEDITOR_HR_COLOR';
        palette.addEventListener('pick', (e) => {
            const color = e.detail || '';
            palette.value = color;
            this.updateOrInsert({
                attr: { style: `--exeditor-hr-color: ${color}` },
                mode: 'merge',
            });
            colorButton.closeDropdown();
        });
        colorButton.appendChild(palette);
        this.editor.on('idlechange', () => {
            const isActive = this.editor
                .selection()
                .isNode((node) => node.isLeaf && node.type.name === this.name);
            if (isActive) {
                colorButton.style.removeProperty('display');
            }
            else {
                colorButton.style.display = 'none';
            }
        });
        return colorButton;
    }
    renderAdvancedDropdown() {
        const dropdownEl = document.createElement('div');
        dropdownEl.slot = 'pop-content';
        const optionEls = this.opt.presetStyles.map((style) => {
            const optionEl = document.createElement('exeditor-toolbar-option');
            optionEl.slot = 'option';
            optionEl.style.width = '100px';
            optionEl.value = style;
            const hr = document.createElement('hr');
            const styles = parseStyle(style);
            // NOTE: if use `Object.assign(hr.style, styles)`, hr.style will set `border-xxx-width` after `border-top`
            const newStyle = stringifyStyles({
                width: '100%',
                ...styles,
                'border-color': '#000',
            });
            hr.setAttribute('style', newStyle);
            optionEl.onclick = () => {
                this.updateOrInsert({
                    attr: { style },
                });
            };
            optionEl.appendChild(hr);
            return optionEl;
        });
        const colorOption = this.renderColorPicker();
        optionEls.push(colorOption);
        const handleMouseEnter = (ev) => {
            if (ev.currentTarget === colorOption) {
                colorOption.openDropdown();
            }
            else {
                colorOption.closeDropdown();
            }
        };
        optionEls.forEach((el) => {
            el.addEventListener('mouseenter', handleMouseEnter);
            dropdownEl.appendChild(el);
        });
        return dropdownEl;
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.hrIcon),
        });
        const dropdown = this.renderAdvancedDropdown();
        btn.append(icon, dropdown);
        btn.addEventListener('buttonclick', () => {
            this.insert();
        });
        btn.label = this.editor.t('分隔线');
        btn.shortcut = 'Mod-_';
        btn.separateDropdown = true;
        return btn;
    }
}
//# sourceMappingURL=index.js.map